<!-- Bell Button -->
<div class="notif-bell-wrapper">
  <button
    mat-icon-button
    matTooltip="Notifications"
    aria-label="Show notifications"
    (click)="toggleDropdown(); $event.stopPropagation()">
    <mat-icon
      aria-hidden="false"
      matBadge="{{ unreadCount }}"
      matBadgeColor="warn"
      matBadgeSize="small"
      matBadgePosition="above after"
      [matBadgeHidden]="unreadCount === 0"
      class="notification-icon">
      notifications
    </mat-icon>
  </button>

  <!-- Dropdown Panel -->
  <div class="notif-dropdown"
       [class.open]="isDropdownOpen"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="notif-dropdown-header">
      <h3>Notifications</h3>
      <div class="notif-dropdown-actions">
        <button mat-icon-button
                matTooltip="Mark all as read"
                [disabled]="unreadCount === 0"
                (click)="onMarkAllRead()">
          <mat-icon>done_all</mat-icon>
        </button>
        <button mat-icon-button
                matTooltip="Notification settings"
                (click)="onOpenSettings()">
          <mat-icon>settings</mat-icon>
        </button>
      </div>
    </div>

    <!-- Tabs -->
    <div class="notif-dropdown-tabs">
      <button class="notif-tab"
              [class.active]="activeTab === 'all'"
              (click)="switchTab('all')">
        All
        <span class="notif-tab-badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
      </button>
      <button class="notif-tab"
              [class.active]="activeTab === 'unread'"
              (click)="switchTab('unread')">
        Unread
      </button>
    </div>

    <!-- Notification List -->
    <div class="notif-dropdown-list">
      <ng-container *ngIf="filteredNotifications.length > 0; else emptyState">
        <div *ngFor="let note of filteredNotifications; let i = index; trackBy: trackByNotifId"
             class="notif-item"
             [class.unread]="!note.isRead"
             (click)="onNotificationClick(note, i)">

          <!-- Avatar -->
          <div class="notif-avatar" [ngClass]="getAvatarConfig(note).cssClass">
            <span class="notif-avatar-initials">{{ note.senderInitials }}</span>
            <span class="notif-avatar-badge" [ngClass]="getAvatarConfig(note).iconClass">
              <mat-icon>{{ getAvatarConfig(note).icon }}</mat-icon>
            </span>
          </div>

          <!-- Content -->
          <div class="notif-content">
            <div class="notif-text" [innerHTML]="highlightMessage(note.message)"></div>

            <!-- Owning company for this notification. Surfaces so the admin knows which client
                 the change belongs to before clicking, and warns when clicking will trigger an
                 organization switch. -->
            <div class="notif-client" *ngIf="companyName(note.companyId) as cname">
              <mat-icon>business</mat-icon>
              <span class="notif-client-name">{{ cname }}</span>
              <span class="notif-switch-hint" *ngIf="isCrossCompany(note)">
                <mat-icon>swap_horiz</mat-icon>
                switches organization
              </span>
            </div>

            <div class="notif-meta">
              <span class="notif-time">
                <mat-icon>schedule</mat-icon>
                {{ note.relativeTime }}
              </span>
              <span class="notif-unread-dot" *ngIf="!note.isRead"></span>
              <span class="notif-tag" *ngIf="getStatusTag(note) as tag" [ngClass]="tag.cssClass">
                {{ tag.label }}
              </span>
            </div>
          </div>

          <!-- Hover Actions -->
          <div class="notif-hover-actions">
            <button mat-icon-button
                    *ngIf="isAdmin && note.leaveRequestId != null"
                    matTooltip="View request"
                    class="notif-action-btn"
                    (click)="onViewLeave(note); $event.stopPropagation()">
              <mat-icon>visibility</mat-icon>
            </button>
            <button mat-icon-button
                    matTooltip="Dismiss"
                    class="notif-action-btn delete"
                    (click)="onDismiss(note, i); $event.stopPropagation()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Empty State -->
      <ng-template #emptyState>
        <div class="notif-empty">
          <mat-icon>notifications_none</mat-icon>
          <span>{{ activeTab === 'unread' ? 'No unread notifications' : 'No notifications yet' }}</span>
        </div>
      </ng-template>
    </div>

    <!-- Footer -->
    <div class="notif-dropdown-footer">
      <a (click)="onViewAll()">
        View All Notifications
        <mat-icon>arrow_forward</mat-icon>
      </a>
    </div>
  </div>
</div>

<!-- Backdrop overlay -->
<div class="notif-overlay"
     *ngIf="isDropdownOpen"
     (click)="closeDropdown()">
</div>
